<template>
  <el-dialog :title="`活动范围`" :visible.sync="modalShow">
    <el-table border stripe v-loading="loading" :data="tableData" style="width: 100%" ref="table">
      <el-table-column prop="companyName" label="业务平台" minWidth="250" align="center"></el-table-column>
      <el-table-column prop="state" label="状态" minWidth="160" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.state == 1">已启用</template>
          <template v-else-if="scope.row.state == 2">已停用</template>
          <template v-else>--</template>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="操作" minWidth="120" align="center">
        <template slot-scope="scope">
          <a class="blue_Box" @click="action_fn(scope.row)">
            <template v-if="scope.row.state == 1">停用</template>
            <template v-else-if="scope.row.state == 2">启用</template>
            <template v-else>--</template>
          </a>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer"></span>
  </el-dialog>
</template>

<script>
import tableMoudel from "@/libs/mixin/table";
import { Admin } from '../api';
export default {
  mixins: [tableMoudel],
  data () {
    return {
      modalShow: false,
      spId: null
    }
  },
  methods: {
    init (spId) {
      this.modalShow = true
      this.spId = spId
      this.getData()
    },
    async getData () {
      const res = await Admin.fanweigetListPage({ spId:this.spId })
      if (res.code !== 0) return
      const { data } = res
      this.tableData = data
    },
    async action_fn (row) {
      const { state,companyId } = row
      const params = {
        companyId,
        spId: this.spId,
        state: state == 1 ? 2 : 1
      }
      const res = await Admin.updateActivitySpCompany(params)
      if (res.code !== 0) return
      this.$message.success('操作成功！')
      this.$bus.$emit('update', true)
      this.modalShow = false
      this.getData()
    }
  }
}
</script>

<style>
</style>